/* Lumra — subtle scroll-reveal. One well-orchestrated effect, not scattered
   micro-interactions. Respects prefers-reduced-motion via the CSS fallback
   in lumra-tokens.css .lumra-reveal rule. Ported from
   prototype/assets/js/reveal.js, retargeted to the .lumra-reveal class used
   by the custom lumra-* sections. */
document.addEventListener('DOMContentLoaded', () => {
  const targets = document.querySelectorAll('.lumra-reveal');
  if (!('IntersectionObserver' in window) || targets.length === 0) {
    targets.forEach((el) => el.classList.add('is-visible'));
    return;
  }
  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
  );
  targets.forEach((el, i) => {
    el.style.transitionDelay = `${(i % 6) * 60}ms`;
    io.observe(el);
  });
});
